export default __webpack_public_path__ + "static/EVENT_MARKER_GREEN-338b341c9bcdeb9760314de56940ce66.png";